import React from "react";
import { PageLayout } from "../components/page-layout";
import EventCreateEdit from "../components/events/event-create-edit";

export const NewEventPage = () => (
  <PageLayout>
    <EventCreateEdit />
    
  </PageLayout>
);
